import {management} from '../../../../index'
import {LogSectorRepository} from '../../../infra/knex/repositories/log_sector'

import {CreateLogSector} from './createLogSector'

export const createLogSectorUseCase=()=>{
    const repository=new LogSectorRepository(management)

    const save= new CreateLogSector(repository)

    return save
}

